import { Environment } from '@1debit/device-intelligence';

export const deviceIntelligenceEnvironment = (
  deployEnvironment: string
): Environment => {
  return deployEnvironment === 'development'
    ? Environment.Development
    : deployEnvironment === 'production'
    ? Environment.Production
    : Environment.NonProduction;
};
